/**
 * @desc    Просто функция фильтрации `filter`
 * @author  RubaXa <trash@rubaxa.org>
 * @licence MIT
 */
(function () {
	'use strict';


	/**
	 * Функция неидентичности двух переменных
	 * @param   {*}  actual
	 * @param   {*}  expected
	 * @returns {boolean}
	 */
	function notEqual(actual, expected) {
		if (actual === expected) {
			return false;
		}

		var expectedType = typeof expected;

		if (
			(expectedType === 'string' || expectedType === 'number' || expectedType === 'boolean') ||
			(actual === null && expected !== null) || (actual !== null && expected === null)
		) {
			return actual != expected;
		}

		// А теперь детально расмотрим
		var key, actualType = typeof actual;

		if (actualType === expectedType) {
			if (expected instanceof Array) {
				key = expected.length;

				while (key--) {
					if (notEqual(actual[key], expected[key])) {
						return true;
					}
				}
			}
			else if (expected instanceof Object) {
				for (key in expected) {
					 if (notEqual(actual[key], expected[key])) {
						 return true
					 }
				}
			}
		}

		return false;
	}


	/**
	 * Создать функцию сравнения
	 * @param   {Function|Object}  fn
	 * @param   {*}                thisArg
	 * @returns {Function}
	 */
	function createIterator(fn, thisArg) {
		var iterator;

		if (typeof fn === 'function') {
			iterator = thisArg
				? function (value, index, array) { return fn.call(thisArg, value, index, array); }
				: fn
			;
		}
		else {
			var keys = Object.keys(fn),
				key = keys[0],
				length = keys.length,
				expected = fn[key]
			;

			if (length === 1) {
				iterator = (key.indexOf('.') === -1)
					? function (actual) { return !notEqual(actual[key], expected); }
					: function (actual, model) { return !notEqual(model.get(key), expected); };
			}
			else {
				iterator = function (actual, model) {
					var idx = length;

					while (idx--) {
						key = keys[idx];

						if (notEqual(key.indexOf('.') === -1 ? actual[key] : model.get(key), fn[key])) {
							return false;
						}
					}

					return true;
				};
			}

			iterator.keys = keys;
			iterator.isWhere = true;
		}

		return iterator;
	}


	/**
	 * Фнукиця фильтрации
	 * @param   {Array|Object} array
	 * @param   {Function}     iterator
	 * @param   {*}            thisArg
	 * @returns {Array}
	 */
	function filter(array, iterator, thisArg) {
		if (!array) {
			return [];
		}

		var result = [],
			i = 0,
			n = array.length
		;

		if (n > 0) {
			iterator = createIterator(iterator, thisArg);

			for (; i < n; i++) {
				if (iterator(array[i], i, array)) {
					result.push(array[i]);
				}
			}
		}
		else if (array instanceof Object) {
			iterator = createIterator(iterator, thisArg);

			for (i in array) {
				if (array.hasOwnProperty(i) && iterator(array[i], i, array)) {
					result.push(array[i]);
				}
			}
		}

		return result;
	}


	filter.version = '0.1.4';
	filter.notEqual = notEqual;
	filter.createIterator = createIterator;


	// Export
	if (typeof define === 'function' && (define.amd || define.ajs)) {
		define('filter', function () { return filter; });
	}
	else if (typeof module != 'undefined' && typeof module.exports != 'undefined') {
		module.exports = filter;
	}
	else {
		window['filter'] = filter;
	}
})();
